import React from "react";

const IconCard: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M0.937447 11.6137C0.937447 12.0529 1.1103 12.4742 1.41797 12.7848C1.72565 13.0954 2.14295 13.2699 2.57807 13.2699H12.4218C12.8569 13.2699 13.2742 13.0954 13.5819 12.7848C13.8896 12.4742 14.0624 12.0529 14.0624 11.6137V7.05911H0.937447V11.6137ZM2.87104 9.36597C2.87104 9.13066 2.96364 8.90498 3.12847 8.73859C3.29329 8.5722 3.51685 8.47872 3.74995 8.47872H5.1562C5.3893 8.47872 5.61285 8.5722 5.77768 8.73859C5.9425 8.90498 6.0351 9.13066 6.0351 9.36597V9.95748C6.0351 10.1928 5.9425 10.4185 5.77768 10.5849C5.61285 10.7513 5.3893 10.8447 5.1562 10.8447H3.74995C3.51685 10.8447 3.29329 10.7513 3.12847 10.5849C2.96364 10.4185 2.87104 10.1928 2.87104 9.95748V9.36597Z"
        fill="#fff"
      />
      <path
        d="M12.4218 2.85907H2.57807C2.14295 2.85907 1.72565 3.03356 1.41797 3.34416C1.1103 3.65476 0.937447 4.07602 0.937447 4.51528V5.28423H14.0624V4.51528C14.0624 4.07602 13.8896 3.65476 13.5819 3.34416C13.2742 3.03356 12.8569 2.85907 12.4218 2.85907Z"
        fill="#fff"
      />
    </svg>
  );
};

export default IconCard;
